import React from 'react';
import BreadcrumbRenderer from '@atlassian/jira-breadcrumbs/src/breadcrumb-renderer/index.tsx';
import ProjectSettingsBreadcrumb from '@atlassian/jira-breadcrumbs/src/common-breadcrumbs/project-settings/index.tsx';
import ProjectBreadcrumb from '@atlassian/jira-breadcrumbs/src/common-breadcrumbs/project/index.tsx';
import PageHeader from '@atlassian/jira-common-components-page-header';
import { useProjectContext } from '@atlassian/jira-providers-project-context';

type Props = {
	title: string;
};

const Header = ({ title }: Props) => {
	const { data: projectContext } = useProjectContext();

	return (
		<PageHeader
			breadcrumbs={
				projectContext && (
					<ProjectBreadcrumb
						baseUrl=""
						projectKey={projectContext.projectKey}
						projectName={projectContext.projectName}
					>
						<ProjectSettingsBreadcrumb
							baseUrl=""
							projectKey={projectContext.projectKey}
							projectType={projectContext.projectType}
							isSimplified={projectContext.simplified}
						>
							<BreadcrumbRenderer />
						</ProjectSettingsBreadcrumb>
					</ProjectBreadcrumb>
				)
			}
		>
			{title}
		</PageHeader>
	);
};

export default Header;
